//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('pohKeynoTopStatus', {
//        templateUrl: 'views/components/views/pohKeynoTopStatus/pohKeynoTopStatus.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'pohKeynoTopStatusService', 'orderlineStatusService', function ($stateParams, utilityService, pohKeynoTopStatusService, orderlineStatusService) {

//            // #region GLOBAL VARIABLES & DEFINITIONS
            
//            const vm = this;
//            let pohKeynoTop = $stateParams.poh_keyno_top;
            
//            vm.model = {
//                pohKeynoTop: pohKeynoTop,
//                bgPohTop: {
//                    selected: 'D',
//                    buttons: [
//                        { id: 'D', label: 'this', color: 'primary', onClick: () => vm.model.bgPohTop.selected = 'D' },
//                        { id: 'INFO', label: 'orderinfo', color: 'primary', onClick: () => vm.model.bgPohTop.selected = 'INFO' },
//                        { id: 'OL', label: 'orderlines', color: 'primary', onClick: () => vm.model.bgPohTop.selected = 'OL' }
//                    ]
//                },
//                menu: {},
//                itemsListPohTops: [],
//                itemsListStatuses: []
//            };

//            // #endregion GLOBAL VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.menu = (await pohKeynoTopStatusService.getEdit({ poh_keyno_top: pohKeynoTop }))[0];
//            }

//            async function loadPohTop() {
//                vm.model.itemsListPohTops = await pohKeynoTopStatusService.listPohTops({ poh_keyno_top: pohKeynoTop });
//            }

//            async function loadStatuses() {
//                if (utilityService.validateParmsValue(vm.model.menu.order_internal_no) !== true) return;

//                return vm.model.itemsListStatuses = await orderlineStatusService.listStatuses({ order_internal_no: vm.model.menu.order_internal_no });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region BUTTON RADIO FUNCTIONS

//            vm.selectBgPohTop = function (value) {
//                vm.model.bgPohTop.selected = value;
//            };

//            // #endregion BUTTON RADIO FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadEdit();
//                loadPohTop();
//                loadStatuses();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
